import { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { Constants } from '@/types/constants';
import RepositoryResponse from '@/types/repositoryResponse';
import ajax from '@/utils/ajax';
import defaultRepositoryError from '@/utils/defaultRepositoryError';
import logAjaxError from '@/utils/logAjaxError';

export const constantsRepository = {
  async getConstants({ host }: { host: string }): Promise<RepositoryResponse<Constants>> {
    try {
      const path = `/api/constants/`;
      const response = await ajax.get({
        url: `${host}${path}`
      });

      return {
        data: response.data,
        isError: false
      };
    } catch (error) {
      logAjaxError(error);
      return defaultRepositoryError(error as AxiosError, 'Failed to get constants data.');
    }
  }
};

const ConstantsRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getConstants(): Promise<RepositoryResponse<Constants>> {
      return constantsRepository.getConstants({ host });
    }
  };
};

export default ConstantsRepository;
